import React from 'react'
import { CefrLevelCode, LanguageCode, Certification } from 'src/types'

import PageWrapupSkeleton from 'src/ui/PageWrapup/PageWrapupSkeleton'
import PageWrapupActions from 'src/ui/PageWrapup/subcomponents/PageWrapupActions/PageWrapupActions'
import LevelWrapupCelebration from './subcomponents/LevelWrapupCelebration/LevelWrapupCelebration'
import LevelWrapupCertificate from './subcomponents/LevelWrapupCertificate/LevelWrapupCertificate'
import LevelWrapupStats from './subcomponents/LevelWrapupStats/LevelWrapupStats'

const toHours = (inMinutes: number): number => {
  const hours = inMinutes / 60

  if (String(hours) === String(Math.round(hours))) {
    return hours
  }

  return Number(hours.toFixed(1))
}

export type Props = {
  cefrLevel: CefrLevelCode
  l2Code: LanguageCode
  fullName: string
  certification: Certification
}

const LevelWrapup: React.FC<Props> = ({
  cefrLevel,
  l2Code,
  certification,
  fullName,
}) => {
  const hoursOfLessons = toHours(certification.liveLessonsInMinutes)
  const hoursOfStudy = toHours(certification.selfStudyInMinutes)

  return (
    <PageWrapupSkeleton
      contentSection={
        <>
          <LevelWrapupCelebration cefrLevel={cefrLevel} l2Code={l2Code} />
          {certification.kind === 'major' ? (
            <LevelWrapupCertificate
              cefrLevel={cefrLevel}
              l2Code={l2Code}
              fullName={fullName}
              hoursOfLessons={hoursOfLessons}
              hoursOfStudy={hoursOfStudy}
              certification={certification}
            />
          ) : (
            <LevelWrapupStats
              hoursOfLessons={hoursOfLessons}
              hoursOfStudy={hoursOfStudy}
              startedAt={certification.startedAt}
              completedAt={certification.completedAt}
            />
          )}
        </>
      }
      actionsSection={<PageWrapupActions />}
    />
  )
}

export default LevelWrapup
